import { LogLevel } from '@azure/msal-browser';
export const msalConfig = {
  auth: {
    tenantId: process.env.REACT_APP_Tenent_id, // Your tenant ID goes here
    clientId: process.env.REACT_APP_client_id, // Your client (application) ID goes here
    authority: process.env.REACT_APP_authority, // Replace the last part with your tenant ID
    redirectUri: window.location.origin, // Must be the same in Azure AD portal, can be replace with an environment variable: process.env.REACT_APP_REDIRECT_URL
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            return;
          case LogLevel.Info:
            return;
          case LogLevel.Verbose:
            return;
          case LogLevel.Warning:
            return;
          default:
            return;
        }
      }
    }
  },
  scopes: ['user.read']
};

export const protectedResources = {
  apiTodoList: {
    endpoint: process.env.REACT_APP_redirectUri,
    scopes: {
      read: [process.env.REACT_APP_read],
      write: [process.env.REACT_APP_write]
    }
  }
};

export const loginRequest = {
  scopes: [
    ...protectedResources.apiTodoList.scopes.read,
    ...protectedResources.apiTodoList.scopes.write
  ]
};
